<template>
    <div>
        <div class="plain-card collapsed">
            <h5 @click.prevent="toggleFilters($event)" class="pointer">
                <i class="fa fa-caret-down pull-left active pen-pink"></i>
                {{ uLang('app.choose_filters') }}
            </h5>

            <div class="form-group row inline-form mt-3">
                <label class="col-md-2 col-xl-2 col-12 col-form-label">{{ uLang('app.date_filter') }}</label>
                <div class="col-md-10 col-xl-10 col-12">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex flex-grow justify-content-between p-1">
                                <vue-pikaday
                                    v-model="filters['date_from']"
                                    :options="options"
                                    :required="false"
                                    placeholder="Van"
                                    class="form-control"
                                    autocomplete="off"
                                />
                                <button v-if="filters['date_from'] !== null"
                                        @click="clearFilter('date_from')"
                                        class="btn btn-brand">
                                    X
                                </button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex flex-grow justify-content-between p-1">
                                <vue-pikaday
                                    v-model="filters['date_to']"
                                    :options="options"
                                    :required="false"
                                    placeholder="Tot"
                                    class="form-control"
                                    autocomplete="off"
                                />
                                <button v-if="filters['date_to'] !== null"
                                        @click="clearFilter('date_to')"
                                        class="btn btn-brand">
                                    X
                                </button>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-brand pull-right" @click="fetchData">{{ uLang('app.filter') }}</button>
                </div>
            </div>
        </div>
        <div class="plain-card">
            <table v-show="!loading">
                <thead>
                    <tr>
                        <th>{{ uLang('app.trajectory_manager') }}</th>
                        <th>{{ uLang('app.total_number_of_lead_trajectories') }}</th>
                        <th>{{ uLang('app.total_number_of_coach_trajectories') }}</th>
                        <th :title="uLang('app.sell_revenue_lead_percentage_explanation')">
                            <i class="fa fa-info-circle pointer"></i>
                            {{ uLang('app.sell_revenue_lead') }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="rebateData.length !== 0">
                    <tr v-for="row in rebateData">
                        <td>
                            <link-if-permissions
                                :to="{ name: 'admin.relations.view', params: { id: row.enrolments[0].trajectory_manager_id }}"
                                permissions="view-relations"
                            >
                                {{ row.enrolments[0].trajectory_manager_full_name }}
                            </link-if-permissions>
                        </td>
                        <td>
                            <span v-if="canClickNumbers(row)"
                                  class="pretend-link"
                                  @click.prevent="showModal(row.lead_enrolments)"
                            >
                                {{ row.lead_enrolments.length }}
                            </span>

                            <span v-else>{{ row.lead_enrolments.length }}</span>
                        </td>
                        <td>
                            <span v-if="canClickNumbers(row)"
                                  class="pretend-link"
                                  @click.prevent="showModal(row.enrolments)"
                            >
                                {{ row.enrolments.length }}
                            </span>

                            <span v-else>{{ row.enrolments.length }}</span>
                        </td>
                        <td>
                            <span class="pull-left">
                                <i class="fa fa-lg fa-euro"></i>
                                {{ row.total_procurement.toFixed(2) }} / {{ row.total_price.toFixed(2) }}
                            </span>
                            <span>
                                ({{ row.sell_revenue_lead_percentage.toFixed(2) }}%)
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <rea-loader :loading="loading"></rea-loader>
        </div>
        <portal v-if="openEnrolmentsModal" to="modals">
            <coach-enrolments-modal ref="modal" :enrolments="selectedEnrolments" @hidden="openEnrolmentsModal = false"/>
        </portal>
    </div>
</template>

<script>
    import { ReaLoader } from "~/components/helpers";
    import { CoachEnrolmentsModal } from "~/components/modals";
    import { mapGetters } from 'vuex'
    import { PikadayOptions } from "~/Form/elements";
    import { ToggleFiltersMixin } from '~/mixins/management-info'

    export default {
        name: 'CoachRebatesReport',

        components: {
            ReaLoader,
            CoachEnrolmentsModal,
        },

        mixins: [ToggleFiltersMixin],

        data() {
            return {
                loading: false,
                enable_filter: false,
                rebateData: [],
                openEnrolmentsModal: false,
                selectedEnrolments: [],
                options: PikadayOptions,
                filters: {
                    date_from: null,
                    date_to: null,
                }
            }
        },

        async mounted() {
            await this.fetchData()
        },

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            async fetchData() {
                this.loading = true;

                let filters = JSON.stringify({
                    'dateFrom': this.filters.date_from ? this.filters.date_from.toDateString() : null,
                    'dateTo': this.filters.date_to ? this.filters.date_to.toDateString() : null
                })

                const { data } = await window.axios.get(route('reports.trajectory_manager.rebates', { filters }))

                this.rebateData = data;
                this.loading = false;
            },
            showModal(enrolments) {
                this.selectedEnrolments = enrolments;
                this.openEnrolmentsModal = true;

                this.$nextTick(() => {
                    this.$refs.modal.$refs.modal.show();
                });
            },
            canClickNumbers(row) {
                const coachId = row.enrolments[0].trajectory_manager_id

                return this.user.can['view-reports'] || this.user.id === coachId
            },
            clearFilter(name) {
                this.filters[name] = null
            }
        },
    }
</script>

<style lang="scss" scoped>
    .fa-caret-down {
        transition: transform .3s ease;

        &.active {
            -webkit-transform: rotate(-180deg);
            -moz-transform: rotate(-180deg);
            -o-transform: rotate(-180deg);
            -ms-transform: rotate(-180deg);
            transform: rotate(-180deg);
        }
    }

    .plain-card {
        overflow: hidden;
        background-color: white;
        padding: 10px 20px 10px 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;

        &.collapsed {
            height: 35px;
        }

        &:not(:first-child) {
            margin-top: 30px;
        }

        .pretend-link {
            color: #c1006d;
            font-weight: 500;
            cursor: pointer;
        }

        h2 {
            margin-bottom: 20px;
        }

        table {
            width: 100%;

            td, th {
                border: 1px solid black;
                padding: 6px;
                text-align: right;
            }

            tbody {
                th {
                    min-width: 190px;
                }
            }
        }
    }
</style>
